import { BottomSheet } from 'doctornow-design-system';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const MaleGuideBottomSheet = ({ isOpen, onClose }: Props) => {
  return (
    <BottomSheet
      type='single'
      title={
        <>
          발기부전약은
          <br />
          비대면 처방이 어려워요
        </>
      }
      description='전립선, 염증 등 다른 증상은 비대면 진료가 가능해요.'
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      buttons={[
        {
          label: '확인했어요',
          variant: 'primary',
          onClick: onClose,
        },
      ]}
    >
      <div className='flex justify-center'>
        <img
          src='https://media.doctornow.co.kr/web_diagnosis_warning.webp'
          alt='male guide'
          className='h-[160px] w-[312px] object-contain'
        />
      </div>
    </BottomSheet>
  );
};

export default MaleGuideBottomSheet;
